import { Box } from '@factorialco/deprecated-design-system'

import { UnionSoftwareType } from 'modules/it_management/lib/software'

import Row from './_Row'

interface Props {
  softwares: UnionSoftwareType[]
  onSelect: (value: string) => void
}

const SoftwareList = ({ softwares, onSelect }: Props) => {
  return (
    <Box maxHeight="s360" overflowY="auto">
      {softwares.map((software) => (
        <Row key={software.id} software={software} onSelect={onSelect} />
      ))}
    </Box>
  )
}

export default SoftwareList
